import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createOrder = (payload) => api.post("/checkout", payload).then((r) => r.data);
export const createDonation = (payload) => api.post("/donations", payload).then((r) => r.data);
export const getDonationStats = () => api.get("/donations/stats").then((r) => r.data);
export const newsletterSignup = (email) => api.post("/newsletter", { email }).then((r) => r.data);

// --- Stripe payments ---
export const createCheckout = (payload) =>
  api.post("/payments/checkout", { origin_url: window.location.origin, ...payload }).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const claimEbook = (payload) =>
  api.post("/ebook/claim", payload).then((r) => r.data);
export const contactMessage = (payload) =>
  api.post("/contact", payload).then((r) => r.data);
